import { useEffect } from 'react'
import { useFeatureTogglesStore } from 'stores/featureTogglesStore'

const ARVORE_PRODUCT_NAME = 'Árvore'
const BIBLION_PRODUCT_NAME = 'BibliON'

export const usePageTitle = (pageTitle?: string) => {
  const { featureToggles } = useFeatureTogglesStore()
  const isBiblion =
    featureToggles?.biblionGeneral === true ||
    featureToggles?.biblionPanel === true

  useEffect(() => {
    if (!pageTitle) return

    const previousTitle = document.title
    const productName = isBiblion ? BIBLION_PRODUCT_NAME : ARVORE_PRODUCT_NAME

    document.title = `${pageTitle} - ${productName}`

    return () => {
      document.title = previousTitle
    }
  }, [pageTitle, isBiblion])
}
